let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ldGmJ")).then(() => parcelRequire('6L7mA'));